import { createContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import useSWR, { useSWRConfig } from 'swr'
import { useRouter } from 'next/router'

export const UserContext = createContext(undefined)

const userSessionApiUrl = '/api/knvb/session'

const UserProvider = (props) => {
  const { children, session } = props

  const { mutate } = useSWRConfig()

  const fetcher = (...args) => fetch(...args).then((res) => res.json())
  const router = useRouter()

  const [loggedIn, setLoggedIn] = useState(!!session && session?.code !== 401)
  const [userSession, setUserSession] = useState(session)
  const [userInitials, setUserInitials] = useState(false)
  const [loadedSession, setLoadedSession] = useState(false)
  const [shouldFetch, setShouldFetch] = useState(true)
  const [sportType, setSportType] = useState(null)

  // shouldFetch blocks this call to be executed multiple times
  // https://swr.vercel.app/docs/conditional-fetching#conditional
  const { data } = useSWR(shouldFetch ? userSessionApiUrl : null, fetcher, {
    fallbackData: session,
    revalidateOnFocus: true,
    errorRetryInterval: 30000
  })

  const updateSession = () => mutate(userSessionApiUrl)

  const clearSession = (data) => {
    setUserSession(data)
    setUserInitials(false)
    setLoggedIn(false)
    router.push('/')
  }

  useEffect(() => {
    if (session) setLoadedSession(true)
    setSportType(process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT)
  }, [])

  useEffect(() => {
    // The data or session was updated and user is logged in but not set as logged in
    if (!loggedIn && data && (data?.code === undefined || session?.code === undefined)) {
      setUserSession(data?.date_created?.date > session?.date_created?.date ? data : session)
      setLoggedIn(true)
    }

    if (loggedIn && data?.code === 401) {
      clearSession(data)
    }
    if (!data) return false
    if (!session && !!data) {
      setUserSession(data)
      setLoggedIn(!!data && data.code !== 401)
      setLoadedSession(true)
    } else if (userSession !== data) {
      setUserSession(data)
    }
    if (session?.sportType) {
      setSportType(session.sportType?.slug)
    }
  }, [data, session])

  return (
    <UserContext.Provider
      value={{
        loggedIn,
        setLoggedIn,
        userSession,
        setUserSession,
        userInitials,
        setUserInitials,
        loadedSession,
        updateSession,
        setShouldFetch,
        sportType,
        setSportType
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

UserProvider.propTypes = {
  children: PropTypes.object,
  session: PropTypes.object
}

export default UserProvider
